module.exports = __webpack_public_path__ + "static/img/book13.c6f8ed0.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/book13.jpg
// module id = aKgL
// module chunks = 1